<template>
  <div>
    <el-dialog title="用户注册协议" :before-close="handleClose" width="1000px" :visible.sync="showproc" class="examination"
      :close-on-click-modal="false" :append-to-body="true" top='50px' center>
      <h3
        style="text-align: center;background-color: rgb(177, 99, 47) ;position: fixed;left: 50%;transform: translateX(-50%);top:0px;height:50px;line-height:50px;width: 1000px;color: #fff;"
        v-if="codeStatus">
        继续在当前页面阅读{{ alltime }}s才可继续进行注册
      </h3>
      <div
        style="padding: 30px 15px 0 15px;background-color: #fff; color: black;padding-bottom: 20px;height: 560px;overflow: auto;">
        <h2 style="text-align: center;margin-bottom: 20px;">植保学院仪器共享平台注册协议</h2>
        <h4>
          本协议由以下双方共同签署：
        </h4>
        <div>
          甲方：植保学院仪器共享平台
        </div>
        <div>
          乙方：注册用户
        </div>
        <p style="text-indent: 2em;">植保学院仪器共享平台（甲方，以下简称平台）为提升设备使用效率，优化资源配置，更好的运行设备共享平台，更好的助力科研发展，特订立本协议。
          乙方在注册成为植保学院仪器共享平台用户前，应认真阅读本协议，并确认同意本协议的全部内容。</p>
        <h3 class="title">一、协议内容</h3>
        <div>
          <div>
            1、注册与账号使用
          </div>
          <p style="text-indent: 2em;">乙方应提供真实、准确、完整的注册信息（必填项），并妥善保管账号和密码，不得将账号转让、出借或赠予他人使用。</p>
          <div>
            2、设备使用和维护
          </div>
          <p style="text-indent: 2em;"> 乙方可在平台规定的范围内使用共享设备，并应按照设备的操作规程和使用说明进行操作，乙方应做好每次试验后的仪器维护和卫生收尾工作。</p>
          <div>
            3、费用支付
          </div>
          <p style="text-indent: 2em;"> 乙方应按照平台公布的费用标准，及时支付设备使用费。</p>
          <div>
            4、禁止行为
          </div>
          <p style="text-indent: 2em;"> 乙方在使用共享平台设备时，应遵守国家法律法规，不得利用平台及设备从事任何违法、违规活动，不得恶意破坏仪器设备，不得私自搬动转借仪器设备。</p>
        </div>
        <h3 class="title">二、违约责任</h3>
        <p style="text-indent: 2em;">若乙方未按照平台规定操作和使用仪器，导致设备损坏，造成损失的，乙方应负责修复或赔偿。</p>
        <p style="text-indent: 2em;">若乙方未及时缴纳使用费，甲方有权暂停乙方的使用权限。</p>
        <h3 class="title">三、免责条款</h3>
        <p style="text-indent: 2em;">甲方对因不可抗力、系统故障、第三方因素等原因导致的服务中断或延迟，不承担责任。</p>
        <h3 class="title">四、争议解决</h3>
        <p style="text-indent: 2em;">因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；</p>
        <p style="text-indent: 2em;">本协议自用户注册后，经审核进入植保学院仪器共享平台之日起生效。</p>
        <p style="text-indent: 2em;">本协议未尽事宜，可由双方协商解决。</p>
      </div>
      <span slot="footer">
        <el-button v-if="!codeStatus" type="primary" @click="getstatus">我已阅读并同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    showproc: {
      type: Boolean,
      default: false
    },
    checked: {
      type: String,
      default: false
    }
  },
  data() {
    return {
      codeStatus: false,
      alltime: 10
    }
  },
  mounted() {
    this.checked == '1' ? null : this.codeStatus = '1'
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    showTime() {
      if (this.codeStatus) {
        var settime = 10
        var j = setInterval(() => {
          settime--
          this.getTime(settime)
          if (settime == 0) {
            clearInterval(j)
          }
        }, 1000);
      }
    },
    getTime(settime) {
      if (settime >= 10) {
        this.alltime = settime
      }
      else if (settime < 10 && settime > 0) {
        this.alltime = '0' + settime
      }
      else {
        this.codeStatus = ''
      }
    },
    getstatus() {
      this.handleClose()
      this.$emit('getValue', this.codeStatus)
    }
  },
  watch: {
    codeStatus(newName, oldName) {
      this.showTime()
    },
    immediate: true
  }

}
</script>
<style lang="scss" scoped>
::v-deep.examination {
  .el-dialog__header {
    border-bottom: 1px #d7dce0 solid;
    padding: 0 0;
    height: 56px;
    line-height: 56px;
    font-weight: 800;
    color: black;

    // color: rgb(76, 110, 184);
    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;

      .el-dialog__close {
        font-size: 24px;
      }
    }
  }

  .el-table tr td {
    height: 60px;
  }
}

.title {
  margin: 12px 0 10px 0;
}
</style>